// DOMPurify wrapper used everywhere HTML from the DB is rendered into
// the DOM. Storefront/admin staff can put HTML into many fields (product
// descriptions, modules, category descriptions, etc.); without this, a
// compromised tenant could plant XSS that runs in customers' browsers.

import DOMPurify from 'dompurify';

export const sanitize = (html: string | null | undefined): string => {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ALLOWED_ATTR: ['href', 'target', 'rel', 'title', 'alt', 'src', 'class', 'style', 'width', 'height'],
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button'],
  });
};
